
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Niklaus H., 96 ans, décédé le 28 mars 2020</b>
    <br />
    <br />
    <i>Un des fils raconte</i>
    <br />
    <p>
  «Fin mars, nous connaissions mal le virus qui avait encore peu tué en Suisse.
  Mon père est mort le 28 mars, deux semaines après l’annonce du confinement. Il
  vivait alors dans une maison de retraite. Nous n’avons pas pu lui rendre
  visite. L’établissement avait déjà interdit tout contact avec l’extérieur. Il
  n’y avait aucune exception possible. Mon père s’en est allé paisiblement. Nous
  avons accepté son décès. Nous ne pouvions rien changer. Mon père n’exprimait
  plus de joie de vivre depuis un certain temps. Son audition était faible. Il
  évitait les contacts sociaux. Il aurait pu mourir du coronavirus ou d’une
  autre maladie.»
    </p>
    <i>Un deuxième fils poursuit:</i>
    <p>
  «Mon père avait exprimé le souhait que, le moment venu, ses derniers instants
  se déroulent rapidement. Et c’est ce qui s’est passé. J’ai une pensée pour le
  personnel des EMS. Ces employés ont une vie professionnelle difficile. Ils
  sont menacés par le Covid-19 tous les jours. Et pendant ce temps, certaines
  personnes dans la vie civile se soucient peu de la sécurité sanitaire. Je
  pense que la Suisse donne à l’individualisme une place très importante. Dans
  ce domaine, notre pays est beaucoup plus proche des États-Unis que de ses
  voisins européens. En Italie, de grandes commémorations ont accompagné la
  vague de décès dus au Covid-19. Dans notre pays, il n’y a rien eu de tout
  cela. Et c’est un paradoxe. Certains ne sont pas touchés par les malades du
  Covid. Ils sont prêts, en revanche, à investir des milliards de francs dans
  des thérapies contre le cancer, qui coûtent très cher et permettent aux
  personnes âgées, les mêmes qui sont menacées par le coronavirus, de survivre
  quelques années de plus.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;